import SearchResultMarkerView from './search_result_marker_view';

export default Backbone.GoogleMaps.MarkerCollectionView.extend({
  markerView: SearchResultMarkerView,

  initialize(options) {
    Backbone.GoogleMaps.MarkerCollectionView.prototype.initialize.apply(this, arguments);

    this.searchResults = options.searchResults;

    // Set the visibility of the markers when the search results change
    this.searchResults.on('change', _.bind(this.onSearchResultsChanged, this));

    // Hide the markers when we do a new search
    Rover.pubSub.on('search:start', _.bind(this.onSearchStart, this));
  },

  onSearchResultsChanged() {
    const self = this;

    if (this.searchResults.get('errors')) {
      return;
    }

    const results = this.searchResults.getResultsForType(this.collection.service_type);

    this.collection.each((marker, index) => {
      const markerView = self.markerViewChildren[marker.cid];
      if (results && index >= results.length) {
        markerView.setVisible(false);
      } else {
        markerView.setVisible(true);
      }
    });
  },

  onSearchStart() {
    _.each(this.markerViewChildren, markerView => {
      markerView.setVisible(false);
    });
  },
});



// WEBPACK FOOTER //
// ./js/backbone/views/search/search_result_marker_collection_view.js